var map = {
	"./audiofiles/1-1.mp3": 1113,
	"./audiofiles/1-10.mp3": 1114,
	"./audiofiles/1-11.mp3": 1115,
	"./audiofiles/1-12.mp3": 1116,
	"./audiofiles/1-13.mp3": 1117,
	"./audiofiles/1-14.mp3": 1118,
	"./audiofiles/1-15.mp3": 1119,
	"./audiofiles/1-16.mp3": 1120,
	"./audiofiles/1-17.mp3": 1121,
	"./audiofiles/1-18.mp3": 1122,
	"./audiofiles/1-19.mp3": 1123,
	"./audiofiles/1-2.mp3": 1124,
	"./audiofiles/1-20.mp3": 1125,
	"./audiofiles/1-3.mp3": 1126,
	"./audiofiles/1-4.mp3": 1127,
	"./audiofiles/1-5.mp3": 1128,
	"./audiofiles/1-6.mp3": 1129,
	"./audiofiles/1-7.mp3": 1130,
	"./audiofiles/1-8.mp3": 1131,
	"./audiofiles/1-9.mp3": 1132,
	"./audiofiles/10-1.mp3": 1133,
	"./audiofiles/10-10.mp3": 1134,
	"./audiofiles/10-11.mp3": 1135,
	"./audiofiles/10-12.mp3": 1136,
	"./audiofiles/10-13.mp3": 1137,
	"./audiofiles/10-14.mp3": 1138,
	"./audiofiles/10-15.mp3": 1139,
	"./audiofiles/10-2.mp3": 1140,
	"./audiofiles/10-3.mp3": 1141,
	"./audiofiles/10-4.mp3": 1142,
	"./audiofiles/10-5.mp3": 1143,
	"./audiofiles/10-6.mp3": 1144,
	"./audiofiles/10-7.mp3": 1145,
	"./audiofiles/10-8.mp3": 1146,
	"./audiofiles/10-9.mp3": 1147,
	"./audiofiles/11-1.mp3": 1148,
	"./audiofiles/11-10.mp3": 1149,
	"./audiofiles/11-2.mp3": 1150,
	"./audiofiles/11-3.mp3": 1151,
	"./audiofiles/11-4.mp3": 1152,
	"./audiofiles/11-5.mp3": 1153,
	"./audiofiles/11-6.mp3": 1154,
	"./audiofiles/11-7.mp3": 1155,
	"./audiofiles/11-8.mp3": 1156,
	"./audiofiles/11-9.mp3": 1157,
	"./audiofiles/12-1.mp3": 1158,
	"./audiofiles/12-10.mp3": 1159,
	"./audiofiles/12-2.mp3": 1160,
	"./audiofiles/12-3.mp3": 1161,
	"./audiofiles/12-4.mp3": 1162,
	"./audiofiles/12-5.mp3": 1163,
	"./audiofiles/12-6.mp3": 1164,
	"./audiofiles/12-7.mp3": 1165,
	"./audiofiles/12-8.mp3": 1166,
	"./audiofiles/12-9.mp3": 1167,
	"./audiofiles/13-1.mp3": 1168,
	"./audiofiles/13-10.mp3": 1169,
	"./audiofiles/13-11.mp3": 1170,
	"./audiofiles/13-12.mp3": 1171,
	"./audiofiles/13-13.mp3": 1172,
	"./audiofiles/13-14.mp3": 1173,
	"./audiofiles/13-15.mp3": 1174,
	"./audiofiles/13-2.mp3": 1175,
	"./audiofiles/13-3.mp3": 1176,
	"./audiofiles/13-4.mp3": 1177,
	"./audiofiles/13-5.mp3": 1178,
	"./audiofiles/13-6.mp3": 1179,
	"./audiofiles/13-7.mp3": 1180,
	"./audiofiles/13-8.mp3": 1181,
	"./audiofiles/13-9.mp3": 1182,
	"./audiofiles/14-1.mp3": 1183,
	"./audiofiles/14-10.mp3": 1184,
	"./audiofiles/14-2.mp3": 1185,
	"./audiofiles/14-3.mp3": 1186,
	"./audiofiles/14-4.mp3": 1187,
	"./audiofiles/14-5.mp3": 1188,
	"./audiofiles/14-6.mp3": 1189,
	"./audiofiles/14-7.mp3": 1190,
	"./audiofiles/14-8.mp3": 1191,
	"./audiofiles/14-9.mp3": 1192,
	"./audiofiles/15-1.mp3": 1193,
	"./audiofiles/15-10.mp3": 1194,
	"./audiofiles/15-2.mp3": 1195,
	"./audiofiles/15-3.mp3": 1196,
	"./audiofiles/15-4.mp3": 1197,
	"./audiofiles/15-5.mp3": 1198,
	"./audiofiles/15-6.mp3": 1199,
	"./audiofiles/15-7.mp3": 1200,
	"./audiofiles/15-8.mp3": 1201,
	"./audiofiles/15-9.mp3": 1202,
	"./audiofiles/16-1.mp3": 1203,
	"./audiofiles/16-10.mp3": 1204,
	"./audiofiles/16-11.mp3": 1205,
	"./audiofiles/16-12.mp3": 1206,
	"./audiofiles/16-13.mp3": 1207,
	"./audiofiles/16-14.mp3": 1208,
	"./audiofiles/16-15.mp3": 1209,
	"./audiofiles/16-16.mp3": 1210,
	"./audiofiles/16-17.mp3": 1211,
	"./audiofiles/16-18.mp3": 1212,
	"./audiofiles/16-19.mp3": 1213,
	"./audiofiles/16-2.mp3": 1214,
	"./audiofiles/16-20.mp3": 1215,
	"./audiofiles/16-3.mp3": 1216,
	"./audiofiles/16-4.mp3": 1217,
	"./audiofiles/16-5.mp3": 1218,
	"./audiofiles/16-6.mp3": 1219,
	"./audiofiles/16-7.mp3": 1220,
	"./audiofiles/16-8.mp3": 1221,
	"./audiofiles/16-9.mp3": 1222,
	"./audiofiles/17-1.mp3": 1223,
	"./audiofiles/17-2.mp3": 1224,
	"./audiofiles/18-1.mp3": 1225,
	"./audiofiles/18-2.mp3": 1226,
	"./audiofiles/19-1.mp3": 1227,
	"./audiofiles/19-10.mp3": 1228,
	"./audiofiles/19-11.mp3": 1229,
	"./audiofiles/19-12.mp3": 1230,
	"./audiofiles/19-13.mp3": 1231,
	"./audiofiles/19-14.mp3": 1232,
	"./audiofiles/19-15.mp3": 1233,
	"./audiofiles/19-2.mp3": 1234,
	"./audiofiles/19-3.mp3": 1235,
	"./audiofiles/19-4.mp3": 1236,
	"./audiofiles/19-5.mp3": 1237,
	"./audiofiles/19-6.mp3": 1238,
	"./audiofiles/19-7.mp3": 1239,
	"./audiofiles/19-8.mp3": 1240,
	"./audiofiles/19-9.mp3": 1241,
	"./audiofiles/2-1.mp3": 1242,
	"./audiofiles/2-2.mp3": 1243,
	"./audiofiles/20-1.mp3": 1244,
	"./audiofiles/20-10.mp3": 1245,
	"./audiofiles/20-11.mp3": 1246,
	"./audiofiles/20-12.mp3": 1247,
	"./audiofiles/20-13.mp3": 1248,
	"./audiofiles/20-14.mp3": 1249,
	"./audiofiles/20-15.mp3": 1250,
	"./audiofiles/20-2.mp3": 1251,
	"./audiofiles/20-3.mp3": 1252,
	"./audiofiles/20-4.mp3": 1253,
	"./audiofiles/20-5.mp3": 1254,
	"./audiofiles/20-6.mp3": 1255,
	"./audiofiles/20-7.mp3": 1256,
	"./audiofiles/20-8.mp3": 1257,
	"./audiofiles/20-9.mp3": 1258,
	"./audiofiles/21-1.mp3": 1259,
	"./audiofiles/21-10.mp3": 1260,
	"./audiofiles/21-11.mp3": 1261,
	"./audiofiles/21-12.mp3": 1262,
	"./audiofiles/21-13.mp3": 1263,
	"./audiofiles/21-14.mp3": 1264,
	"./audiofiles/21-15.mp3": 1265,
	"./audiofiles/21-2.mp3": 1266,
	"./audiofiles/21-3.mp3": 1267,
	"./audiofiles/21-4.mp3": 1268,
	"./audiofiles/21-5.mp3": 1269,
	"./audiofiles/21-6.mp3": 1270,
	"./audiofiles/21-7.mp3": 1271,
	"./audiofiles/21-8.mp3": 1272,
	"./audiofiles/21-9.mp3": 1273,
	"./audiofiles/22-1.mp3": 1274,
	"./audiofiles/22-10.mp3": 1275,
	"./audiofiles/22-2.mp3": 1276,
	"./audiofiles/22-3.mp3": 1277,
	"./audiofiles/22-4.mp3": 1278,
	"./audiofiles/22-5.mp3": 1279,
	"./audiofiles/22-6.mp3": 1280,
	"./audiofiles/22-7.mp3": 1281,
	"./audiofiles/22-8.mp3": 1282,
	"./audiofiles/22-9.mp3": 1283,
	"./audiofiles/23-1.mp3": 1284,
	"./audiofiles/23-10.mp3": 1285,
	"./audiofiles/23-2.mp3": 1286,
	"./audiofiles/23-3.mp3": 1287,
	"./audiofiles/23-4.mp3": 1288,
	"./audiofiles/23-5.mp3": 1289,
	"./audiofiles/23-6.mp3": 1290,
	"./audiofiles/23-7.mp3": 1291,
	"./audiofiles/23-8.mp3": 1292,
	"./audiofiles/23-9.mp3": 1293,
	"./audiofiles/24-1.mp3": 1294,
	"./audiofiles/24-10.mp3": 1295,
	"./audiofiles/24-2.mp3": 1296,
	"./audiofiles/24-3.mp3": 1297,
	"./audiofiles/24-4.mp3": 1298,
	"./audiofiles/24-5.mp3": 1299,
	"./audiofiles/24-6.mp3": 1300,
	"./audiofiles/24-7.mp3": 1301,
	"./audiofiles/24-8.mp3": 1302,
	"./audiofiles/24-9.mp3": 1303,
	"./audiofiles/25-1.mp3": 1304,
	"./audiofiles/25-10.mp3": 1305,
	"./audiofiles/25-11.mp3": 1306,
	"./audiofiles/25-12.mp3": 1307,
	"./audiofiles/25-13.mp3": 1308,
	"./audiofiles/25-14.mp3": 1309,
	"./audiofiles/25-15.mp3": 1310,
	"./audiofiles/25-2.mp3": 1311,
	"./audiofiles/25-3.mp3": 1312,
	"./audiofiles/25-4.mp3": 1313,
	"./audiofiles/25-5.mp3": 1314,
	"./audiofiles/25-6.mp3": 1315,
	"./audiofiles/25-7.mp3": 1316,
	"./audiofiles/25-8.mp3": 1317,
	"./audiofiles/25-9.mp3": 1318,
	"./audiofiles/26-1.mp3": 1319,
	"./audiofiles/26-10.mp3": 1320,
	"./audiofiles/26-2.mp3": 1321,
	"./audiofiles/26-3.mp3": 1322,
	"./audiofiles/26-4.mp3": 1323,
	"./audiofiles/26-5.mp3": 1324,
	"./audiofiles/26-6.mp3": 1325,
	"./audiofiles/26-7.mp3": 1326,
	"./audiofiles/26-8.mp3": 1327,
	"./audiofiles/26-9.mp3": 1328,
	"./audiofiles/27-1.mp3": 1329,
	"./audiofiles/27-10.mp3": 1330,
	"./audiofiles/27-2.mp3": 1331,
	"./audiofiles/27-3.mp3": 1332,
	"./audiofiles/27-4.mp3": 1333,
	"./audiofiles/27-5.mp3": 1334,
	"./audiofiles/27-6.mp3": 1335,
	"./audiofiles/27-7.mp3": 1336,
	"./audiofiles/27-8.mp3": 1337,
	"./audiofiles/27-9.mp3": 1338,
	"./audiofiles/28-1.mp3": 1339,
	"./audiofiles/28-10.mp3": 1340,
	"./audiofiles/28-2.mp3": 1341,
	"./audiofiles/28-3.mp3": 1342,
	"./audiofiles/28-4.mp3": 1343,
	"./audiofiles/28-5.mp3": 1344,
	"./audiofiles/28-6.mp3": 1345,
	"./audiofiles/28-7.mp3": 1346,
	"./audiofiles/28-8.mp3": 1347,
	"./audiofiles/28-9.mp3": 1348,
	"./audiofiles/29-1.mp3": 1349,
	"./audiofiles/29-10.mp3": 1350,
	"./audiofiles/29-2.mp3": 1351,
	"./audiofiles/29-3.mp3": 1352,
	"./audiofiles/29-4.mp3": 1353,
	"./audiofiles/29-5.mp3": 1354,
	"./audiofiles/29-6.mp3": 1355,
	"./audiofiles/29-7.mp3": 1356,
	"./audiofiles/29-8.mp3": 1357,
	"./audiofiles/29-9.mp3": 1358,
	"./audiofiles/3-1.mp3": 1359,
	"./audiofiles/3-10.mp3": 1360,
	"./audiofiles/3-2.mp3": 1361,
	"./audiofiles/3-3.mp3": 1362,
	"./audiofiles/3-4.mp3": 1363,
	"./audiofiles/3-5.mp3": 1364,
	"./audiofiles/3-6.mp3": 1365,
	"./audiofiles/3-7.mp3": 1366,
	"./audiofiles/3-8.mp3": 1367,
	"./audiofiles/3-9.mp3": 1368,
	"./audiofiles/30-1.mp3": 1369,
	"./audiofiles/30-10.mp3": 1370,
	"./audiofiles/30-11.mp3": 1371,
	"./audiofiles/30-12.mp3": 1372,
	"./audiofiles/30-13.mp3": 1373,
	"./audiofiles/30-14.mp3": 1374,
	"./audiofiles/30-15.mp3": 1375,
	"./audiofiles/30-2.mp3": 1376,
	"./audiofiles/30-3.mp3": 1377,
	"./audiofiles/30-4.mp3": 1378,
	"./audiofiles/30-5.mp3": 1379,
	"./audiofiles/30-6.mp3": 1380,
	"./audiofiles/30-7.mp3": 1381,
	"./audiofiles/30-8.mp3": 1382,
	"./audiofiles/30-9.mp3": 1383,
	"./audiofiles/31-1.mp3": 1384,
	"./audiofiles/31-10.mp3": 1385,
	"./audiofiles/31-2.mp3": 1386,
	"./audiofiles/31-3.mp3": 1387,
	"./audiofiles/31-4.mp3": 1388,
	"./audiofiles/31-5.mp3": 1389,
	"./audiofiles/31-6.mp3": 1390,
	"./audiofiles/31-7.mp3": 1391,
	"./audiofiles/31-8.mp3": 1392,
	"./audiofiles/31-9.mp3": 1393,
	"./audiofiles/32-1.mp3": 1394,
	"./audiofiles/32-10.mp3": 1395,
	"./audiofiles/32-11.mp3": 1396,
	"./audiofiles/32-12.mp3": 1397,
	"./audiofiles/32-13.mp3": 1398,
	"./audiofiles/32-14.mp3": 1399,
	"./audiofiles/32-15.mp3": 1400,
	"./audiofiles/32-2.mp3": 1401,
	"./audiofiles/32-3.mp3": 1402,
	"./audiofiles/32-4.mp3": 1403,
	"./audiofiles/32-5.mp3": 1404,
	"./audiofiles/32-6.mp3": 1405,
	"./audiofiles/32-7.mp3": 1406,
	"./audiofiles/32-8.mp3": 1407,
	"./audiofiles/32-9.mp3": 1408,
	"./audiofiles/33-1.mp3": 1409,
	"./audiofiles/33-10.mp3": 1410,
	"./audiofiles/33-11.mp3": 1411,
	"./audiofiles/33-12.mp3": 1412,
	"./audiofiles/33-13.mp3": 1413,
	"./audiofiles/33-14.mp3": 1414,
	"./audiofiles/33-15.mp3": 1415,
	"./audiofiles/33-2.mp3": 1416,
	"./audiofiles/33-3.mp3": 1417,
	"./audiofiles/33-4.mp3": 1418,
	"./audiofiles/33-5.mp3": 1419,
	"./audiofiles/33-6.mp3": 1420,
	"./audiofiles/33-7.mp3": 1421,
	"./audiofiles/33-8.mp3": 1422,
	"./audiofiles/33-9.mp3": 1423,
	"./audiofiles/34-1.mp3": 1424,
	"./audiofiles/34-10.mp3": 1425,
	"./audiofiles/34-11.mp3": 1426,
	"./audiofiles/34-12.mp3": 1427,
	"./audiofiles/34-13.mp3": 1428,
	"./audiofiles/34-14.mp3": 1429,
	"./audiofiles/34-15.mp3": 1430,
	"./audiofiles/34-2.mp3": 1431,
	"./audiofiles/34-3.mp3": 1432,
	"./audiofiles/34-4.mp3": 1433,
	"./audiofiles/34-5.mp3": 1434,
	"./audiofiles/34-6.mp3": 1435,
	"./audiofiles/34-7.mp3": 1436,
	"./audiofiles/34-8.mp3": 1437,
	"./audiofiles/34-9.mp3": 1438,
	"./audiofiles/35-1.mp3": 1439,
	"./audiofiles/35-10.mp3": 1440,
	"./audiofiles/35-2.mp3": 1441,
	"./audiofiles/35-3.mp3": 1442,
	"./audiofiles/35-4.mp3": 1443,
	"./audiofiles/35-5.mp3": 1444,
	"./audiofiles/35-6.mp3": 1445,
	"./audiofiles/35-7.mp3": 1446,
	"./audiofiles/35-8.mp3": 1447,
	"./audiofiles/35-9.mp3": 1448,
	"./audiofiles/36-1.mp3": 1449,
	"./audiofiles/36-10.mp3": 1450,
	"./audiofiles/36-11.mp3": 1451,
	"./audiofiles/36-12.mp3": 1452,
	"./audiofiles/36-13.mp3": 1453,
	"./audiofiles/36-14.mp3": 1454,
	"./audiofiles/36-15.mp3": 1455,
	"./audiofiles/36-2.mp3": 1456,
	"./audiofiles/36-3.mp3": 1457,
	"./audiofiles/36-4.mp3": 1458,
	"./audiofiles/36-5.mp3": 1459,
	"./audiofiles/36-6.mp3": 1460,
	"./audiofiles/36-7.mp3": 1461,
	"./audiofiles/36-8.mp3": 1462,
	"./audiofiles/36-9.mp3": 1463,
	"./audiofiles/37-1.mp3": 1464,
	"./audiofiles/37-10.mp3": 1465,
	"./audiofiles/37-2.mp3": 1466,
	"./audiofiles/37-3.mp3": 1467,
	"./audiofiles/37-4.mp3": 1468,
	"./audiofiles/37-5.mp3": 1469,
	"./audiofiles/37-6.mp3": 1470,
	"./audiofiles/37-7.mp3": 1471,
	"./audiofiles/37-8.mp3": 1472,
	"./audiofiles/37-9.mp3": 1473,
	"./audiofiles/38-1.mp3": 1474,
	"./audiofiles/38-10.mp3": 1475,
	"./audiofiles/38-2.mp3": 1476,
	"./audiofiles/38-3.mp3": 1477,
	"./audiofiles/38-4.mp3": 1478,
	"./audiofiles/38-5.mp3": 1479,
	"./audiofiles/38-6.mp3": 1480,
	"./audiofiles/38-7.mp3": 1481,
	"./audiofiles/38-8.mp3": 1482,
	"./audiofiles/38-9.mp3": 1483,
	"./audiofiles/39-1.mp3": 1484,
	"./audiofiles/39-2.mp3": 1485,
	"./audiofiles/4-1.mp3": 1486,
	"./audiofiles/4-10.mp3": 1487,
	"./audiofiles/4-2.mp3": 1488,
	"./audiofiles/4-3.mp3": 1489,
	"./audiofiles/4-4.mp3": 1490,
	"./audiofiles/4-5.mp3": 1491,
	"./audiofiles/4-6.mp3": 1492,
	"./audiofiles/4-7.mp3": 1493,
	"./audiofiles/4-8.mp3": 1494,
	"./audiofiles/4-9.mp3": 1495,
	"./audiofiles/40-1.mp3": 1496,
	"./audiofiles/40-10.mp3": 1497,
	"./audiofiles/40-11.mp3": 1498,
	"./audiofiles/40-12.mp3": 1499,
	"./audiofiles/40-13.mp3": 1500,
	"./audiofiles/40-14.mp3": 1501,
	"./audiofiles/40-15.mp3": 1502,
	"./audiofiles/40-2.mp3": 1503,
	"./audiofiles/40-3.mp3": 1504,
	"./audiofiles/40-4.mp3": 1505,
	"./audiofiles/40-5.mp3": 1506,
	"./audiofiles/40-6.mp3": 1507,
	"./audiofiles/40-7.mp3": 1508,
	"./audiofiles/40-8.mp3": 1509,
	"./audiofiles/40-9.mp3": 1510,
	"./audiofiles/41-1.mp3": 1511,
	"./audiofiles/41-10.mp3": 1512,
	"./audiofiles/41-11.mp3": 1513,
	"./audiofiles/41-12.mp3": 1514,
	"./audiofiles/41-13.mp3": 1515,
	"./audiofiles/41-14.mp3": 1516,
	"./audiofiles/41-15.mp3": 1517,
	"./audiofiles/41-2.mp3": 1518,
	"./audiofiles/41-3.mp3": 1519,
	"./audiofiles/41-4.mp3": 1520,
	"./audiofiles/41-5.mp3": 1521,
	"./audiofiles/41-6.mp3": 1522,
	"./audiofiles/41-7.mp3": 1523,
	"./audiofiles/41-8.mp3": 1524,
	"./audiofiles/41-9.mp3": 1525,
	"./audiofiles/42-1.mp3": 1526,
	"./audiofiles/42-10.mp3": 1527,
	"./audiofiles/42-2.mp3": 1528,
	"./audiofiles/42-3.mp3": 1529,
	"./audiofiles/42-4.mp3": 1530,
	"./audiofiles/42-5.mp3": 1531,
	"./audiofiles/42-6.mp3": 1532,
	"./audiofiles/42-7.mp3": 1533,
	"./audiofiles/42-8.mp3": 1534,
	"./audiofiles/42-9.mp3": 1535,
	"./audiofiles/43-1.mp3": 1536,
	"./audiofiles/43-10.mp3": 1537,
	"./audiofiles/43-2.mp3": 1538,
	"./audiofiles/43-3.mp3": 1539,
	"./audiofiles/43-4.mp3": 1540,
	"./audiofiles/43-5.mp3": 1541,
	"./audiofiles/43-6.mp3": 1542,
	"./audiofiles/43-7.mp3": 1543,
	"./audiofiles/43-8.mp3": 1544,
	"./audiofiles/43-9.mp3": 1545,
	"./audiofiles/44-1.mp3": 1546,
	"./audiofiles/5-1.mp3": 1547,
	"./audiofiles/5-10.mp3": 1548,
	"./audiofiles/5-2.mp3": 1549,
	"./audiofiles/5-3.mp3": 1550,
	"./audiofiles/5-4.mp3": 1551,
	"./audiofiles/5-5.mp3": 1552,
	"./audiofiles/5-6.mp3": 1553,
	"./audiofiles/5-7.mp3": 1554,
	"./audiofiles/5-8.mp3": 1555,
	"./audiofiles/5-9.mp3": 1556,
	"./audiofiles/6-1.mp3": 1557,
	"./audiofiles/6-10.mp3": 1558,
	"./audiofiles/6-2.mp3": 1559,
	"./audiofiles/6-3.mp3": 1560,
	"./audiofiles/6-4.mp3": 1561,
	"./audiofiles/6-5.mp3": 1562,
	"./audiofiles/6-6.mp3": 1563,
	"./audiofiles/6-7.mp3": 1564,
	"./audiofiles/6-8.mp3": 1565,
	"./audiofiles/6-9.mp3": 1566,
	"./audiofiles/7-1.mp3": 1567,
	"./audiofiles/7-10.mp3": 1568,
	"./audiofiles/7-11.mp3": 1569,
	"./audiofiles/7-12.mp3": 1570,
	"./audiofiles/7-13.mp3": 1571,
	"./audiofiles/7-14.mp3": 1572,
	"./audiofiles/7-15.mp3": 1573,
	"./audiofiles/7-2.mp3": 1574,
	"./audiofiles/7-3.mp3": 1575,
	"./audiofiles/7-4.mp3": 1576,
	"./audiofiles/7-5.mp3": 1577,
	"./audiofiles/7-6.mp3": 1578,
	"./audiofiles/7-7.mp3": 1579,
	"./audiofiles/7-8.mp3": 1580,
	"./audiofiles/7-9.mp3": 1581,
	"./audiofiles/8-1.mp3": 1582,
	"./audiofiles/8-10.mp3": 1583,
	"./audiofiles/8-2.mp3": 1584,
	"./audiofiles/8-3.mp3": 1585,
	"./audiofiles/8-4.mp3": 1586,
	"./audiofiles/8-5.mp3": 1587,
	"./audiofiles/8-6.mp3": 1588,
	"./audiofiles/8-7.mp3": 1589,
	"./audiofiles/8-8.mp3": 1590,
	"./audiofiles/8-9.mp3": 1591,
	"./audiofiles/9-1.mp3": 1592,
	"./audiofiles/9-10.mp3": 1593,
	"./audiofiles/9-2.mp3": 1594,
	"./audiofiles/9-3.mp3": 1595,
	"./audiofiles/9-4.mp3": 1596,
	"./audiofiles/9-5.mp3": 1597,
	"./audiofiles/9-6.mp3": 1598,
	"./audiofiles/9-7.mp3": 1599,
	"./audiofiles/9-8.mp3": 1600,
	"./audiofiles/9-9.mp3": 1601,
	"./audiofiles/audioAdjustment.mp3": 1602,
	"./audiofiles/sample_Triangel.mp3": 1603,
	"./audiofilesPlus/1-1.mp3": 1604,
	"./audiofilesPlus/1-2.mp3": 1605,
	"./audiofilesPlus/1-3.mp3": 1606,
	"./audiofilesPlus/1-4.mp3": 1607,
	"./audiofilesPlus/1-5.mp3": 1608,
	"./audiofilesPlus/1-6.mp3": 1609,
	"./audiofilesPlus/10-1.mp3": 1610,
	"./audiofilesPlus/10-2.mp3": 1611,
	"./audiofilesPlus/10-3.mp3": 1612,
	"./audiofilesPlus/10-4.mp3": 1613,
	"./audiofilesPlus/10-5.mp3": 1614,
	"./audiofilesPlus/10-6.mp3": 1615,
	"./audiofilesPlus/11-1.mp3": 1616,
	"./audiofilesPlus/11-10.mp3": 1617,
	"./audiofilesPlus/11-11.mp3": 1618,
	"./audiofilesPlus/11-12.mp3": 1619,
	"./audiofilesPlus/11-13.mp3": 1620,
	"./audiofilesPlus/11-14.mp3": 1621,
	"./audiofilesPlus/11-15.mp3": 1622,
	"./audiofilesPlus/11-2.mp3": 1623,
	"./audiofilesPlus/11-3.mp3": 1624,
	"./audiofilesPlus/11-4.mp3": 1625,
	"./audiofilesPlus/11-5.mp3": 1626,
	"./audiofilesPlus/11-6.mp3": 1627,
	"./audiofilesPlus/11-7.mp3": 1628,
	"./audiofilesPlus/11-8.mp3": 1629,
	"./audiofilesPlus/11-9.mp3": 1630,
	"./audiofilesPlus/12-1.mp3": 1631,
	"./audiofilesPlus/12-10.mp3": 1632,
	"./audiofilesPlus/12-2.mp3": 1633,
	"./audiofilesPlus/12-3.mp3": 1634,
	"./audiofilesPlus/12-4.mp3": 1635,
	"./audiofilesPlus/12-5.mp3": 1636,
	"./audiofilesPlus/12-6.mp3": 1637,
	"./audiofilesPlus/12-7.mp3": 1638,
	"./audiofilesPlus/12-8.mp3": 1639,
	"./audiofilesPlus/12-9.mp3": 1640,
	"./audiofilesPlus/13-1.mp3": 1641,
	"./audiofilesPlus/13-2.mp3": 1642,
	"./audiofilesPlus/13-3.mp3": 1643,
	"./audiofilesPlus/13-4.mp3": 1644,
	"./audiofilesPlus/13-5.mp3": 1645,
	"./audiofilesPlus/13-6.mp3": 1646,
	"./audiofilesPlus/14-1.mp3": 1647,
	"./audiofilesPlus/14-10.mp3": 1648,
	"./audiofilesPlus/14-2.mp3": 1649,
	"./audiofilesPlus/14-3.mp3": 1650,
	"./audiofilesPlus/14-4.mp3": 1651,
	"./audiofilesPlus/14-5.mp3": 1652,
	"./audiofilesPlus/14-6.mp3": 1653,
	"./audiofilesPlus/14-7.mp3": 1654,
	"./audiofilesPlus/14-8.mp3": 1655,
	"./audiofilesPlus/14-9.mp3": 1656,
	"./audiofilesPlus/15-1.mp3": 1657,
	"./audiofilesPlus/15-10.mp3": 1658,
	"./audiofilesPlus/15-2.mp3": 1659,
	"./audiofilesPlus/15-3.mp3": 1660,
	"./audiofilesPlus/15-4.mp3": 1661,
	"./audiofilesPlus/15-5.mp3": 1662,
	"./audiofilesPlus/15-6.mp3": 1663,
	"./audiofilesPlus/15-7.mp3": 1664,
	"./audiofilesPlus/15-8.mp3": 1665,
	"./audiofilesPlus/15-9.mp3": 1666,
	"./audiofilesPlus/16-1.mp3": 1667,
	"./audiofilesPlus/16-10.mp3": 1668,
	"./audiofilesPlus/16-11.mp3": 1669,
	"./audiofilesPlus/16-12.mp3": 1670,
	"./audiofilesPlus/16-13.mp3": 1671,
	"./audiofilesPlus/16-14.mp3": 1672,
	"./audiofilesPlus/16-15.mp3": 1673,
	"./audiofilesPlus/16-2.mp3": 1674,
	"./audiofilesPlus/16-3.mp3": 1675,
	"./audiofilesPlus/16-4.mp3": 1676,
	"./audiofilesPlus/16-5.mp3": 1677,
	"./audiofilesPlus/16-6.mp3": 1678,
	"./audiofilesPlus/16-7.mp3": 1679,
	"./audiofilesPlus/16-8.mp3": 1680,
	"./audiofilesPlus/16-9.mp3": 1681,
	"./audiofilesPlus/17-1.mp3": 1682,
	"./audiofilesPlus/17-10.mp3": 1683,
	"./audiofilesPlus/17-2.mp3": 1684,
	"./audiofilesPlus/17-3.mp3": 1685,
	"./audiofilesPlus/17-4.mp3": 1686,
	"./audiofilesPlus/17-5.mp3": 1687,
	"./audiofilesPlus/17-6.mp3": 1688,
	"./audiofilesPlus/17-7.mp3": 1689,
	"./audiofilesPlus/17-8.mp3": 1690,
	"./audiofilesPlus/17-9.mp3": 1691,
	"./audiofilesPlus/18-1.mp3": 1692,
	"./audiofilesPlus/18-10.mp3": 1693,
	"./audiofilesPlus/18-11.mp3": 1694,
	"./audiofilesPlus/18-2.mp3": 1695,
	"./audiofilesPlus/18-3.mp3": 1696,
	"./audiofilesPlus/18-4.mp3": 1697,
	"./audiofilesPlus/18-5.mp3": 1698,
	"./audiofilesPlus/18-6.mp3": 1699,
	"./audiofilesPlus/18-7.mp3": 1700,
	"./audiofilesPlus/18-8.mp3": 1701,
	"./audiofilesPlus/18-9.mp3": 1702,
	"./audiofilesPlus/19-1.mp3": 1703,
	"./audiofilesPlus/19-10.mp3": 1704,
	"./audiofilesPlus/19-11.mp3": 1705,
	"./audiofilesPlus/19-12.mp3": 1706,
	"./audiofilesPlus/19-13.mp3": 1707,
	"./audiofilesPlus/19-14.mp3": 1708,
	"./audiofilesPlus/19-15.mp3": 1709,
	"./audiofilesPlus/19-2.mp3": 1710,
	"./audiofilesPlus/19-3.mp3": 1711,
	"./audiofilesPlus/19-4.mp3": 1712,
	"./audiofilesPlus/19-5.mp3": 1713,
	"./audiofilesPlus/19-6.mp3": 1714,
	"./audiofilesPlus/19-7.mp3": 1715,
	"./audiofilesPlus/19-8.mp3": 1716,
	"./audiofilesPlus/19-9.mp3": 1717,
	"./audiofilesPlus/2-1.mp3": 1718,
	"./audiofilesPlus/2-2.mp3": 1719,
	"./audiofilesPlus/2-3.mp3": 1720,
	"./audiofilesPlus/20-1.mp3": 1721,
	"./audiofilesPlus/20-10.mp3": 1722,
	"./audiofilesPlus/20-2.mp3": 1723,
	"./audiofilesPlus/20-3.mp3": 1724,
	"./audiofilesPlus/20-4.mp3": 1725,
	"./audiofilesPlus/20-5.mp3": 1726,
	"./audiofilesPlus/20-6.mp3": 1727,
	"./audiofilesPlus/20-7.mp3": 1728,
	"./audiofilesPlus/20-8.mp3": 1729,
	"./audiofilesPlus/20-9.mp3": 1730,
	"./audiofilesPlus/21-1.mp3": 1731,
	"./audiofilesPlus/21-10.mp3": 1732,
	"./audiofilesPlus/21-2.mp3": 1733,
	"./audiofilesPlus/21-3.mp3": 1734,
	"./audiofilesPlus/21-4.mp3": 1735,
	"./audiofilesPlus/21-5.mp3": 1736,
	"./audiofilesPlus/21-6.mp3": 1737,
	"./audiofilesPlus/21-7.mp3": 1738,
	"./audiofilesPlus/21-8.mp3": 1739,
	"./audiofilesPlus/21-9.mp3": 1740,
	"./audiofilesPlus/22-1.mp3": 1741,
	"./audiofilesPlus/22-10.mp3": 1742,
	"./audiofilesPlus/22-2.mp3": 1743,
	"./audiofilesPlus/22-3.mp3": 1744,
	"./audiofilesPlus/22-4.mp3": 1745,
	"./audiofilesPlus/22-5.mp3": 1746,
	"./audiofilesPlus/22-6.mp3": 1747,
	"./audiofilesPlus/22-7.mp3": 1748,
	"./audiofilesPlus/22-8.mp3": 1749,
	"./audiofilesPlus/22-9.mp3": 1750,
	"./audiofilesPlus/23-1.mp3": 1751,
	"./audiofilesPlus/23-10.mp3": 1752,
	"./audiofilesPlus/23-2.mp3": 1753,
	"./audiofilesPlus/23-3.mp3": 1754,
	"./audiofilesPlus/23-4.mp3": 1755,
	"./audiofilesPlus/23-5.mp3": 1756,
	"./audiofilesPlus/23-6.mp3": 1757,
	"./audiofilesPlus/23-7.mp3": 1758,
	"./audiofilesPlus/23-8.mp3": 1759,
	"./audiofilesPlus/23-9.mp3": 1760,
	"./audiofilesPlus/24-1.mp3": 1761,
	"./audiofilesPlus/24-10.mp3": 1762,
	"./audiofilesPlus/24-2.mp3": 1763,
	"./audiofilesPlus/24-3.mp3": 1764,
	"./audiofilesPlus/24-4.mp3": 1765,
	"./audiofilesPlus/24-5.mp3": 1766,
	"./audiofilesPlus/24-6.mp3": 1767,
	"./audiofilesPlus/24-7.mp3": 1768,
	"./audiofilesPlus/24-8.mp3": 1769,
	"./audiofilesPlus/24-9.mp3": 1770,
	"./audiofilesPlus/25-1.mp3": 1771,
	"./audiofilesPlus/25-2.mp3": 1772,
	"./audiofilesPlus/25-3.mp3": 1773,
	"./audiofilesPlus/25-4.mp3": 1774,
	"./audiofilesPlus/25-5.mp3": 1775,
	"./audiofilesPlus/26-1.mp3": 1776,
	"./audiofilesPlus/26-10.mp3": 1777,
	"./audiofilesPlus/26-11.mp3": 1778,
	"./audiofilesPlus/26-12.mp3": 1779,
	"./audiofilesPlus/26-13.mp3": 1780,
	"./audiofilesPlus/26-14.mp3": 1781,
	"./audiofilesPlus/26-15.mp3": 1782,
	"./audiofilesPlus/26-2.mp3": 1783,
	"./audiofilesPlus/26-3.mp3": 1784,
	"./audiofilesPlus/26-4.mp3": 1785,
	"./audiofilesPlus/26-5.mp3": 1786,
	"./audiofilesPlus/26-6.mp3": 1787,
	"./audiofilesPlus/26-7.mp3": 1788,
	"./audiofilesPlus/26-8.mp3": 1789,
	"./audiofilesPlus/26-9.mp3": 1790,
	"./audiofilesPlus/27-1.mp3": 1791,
	"./audiofilesPlus/27-10.mp3": 1792,
	"./audiofilesPlus/27-11.mp3": 1793,
	"./audiofilesPlus/27-12.mp3": 1794,
	"./audiofilesPlus/27-2.mp3": 1795,
	"./audiofilesPlus/27-3.mp3": 1796,
	"./audiofilesPlus/27-4.mp3": 1797,
	"./audiofilesPlus/27-5.mp3": 1798,
	"./audiofilesPlus/27-6.mp3": 1799,
	"./audiofilesPlus/27-7.mp3": 1800,
	"./audiofilesPlus/27-8.mp3": 1801,
	"./audiofilesPlus/27-9.mp3": 1802,
	"./audiofilesPlus/28-1.mp3": 1803,
	"./audiofilesPlus/28-10.mp3": 1804,
	"./audiofilesPlus/28-2.mp3": 1805,
	"./audiofilesPlus/28-3.mp3": 1806,
	"./audiofilesPlus/28-4.mp3": 1807,
	"./audiofilesPlus/28-5.mp3": 1808,
	"./audiofilesPlus/28-6.mp3": 1809,
	"./audiofilesPlus/28-7.mp3": 1810,
	"./audiofilesPlus/28-8.mp3": 1811,
	"./audiofilesPlus/28-9.mp3": 1812,
	"./audiofilesPlus/29-1.mp3": 1813,
	"./audiofilesPlus/29-10.mp3": 1814,
	"./audiofilesPlus/29-11.mp3": 1815,
	"./audiofilesPlus/29-12.mp3": 1816,
	"./audiofilesPlus/29-13.mp3": 1817,
	"./audiofilesPlus/29-14.mp3": 1818,
	"./audiofilesPlus/29-15.mp3": 1819,
	"./audiofilesPlus/29-2.mp3": 1820,
	"./audiofilesPlus/29-3.mp3": 1821,
	"./audiofilesPlus/29-4.mp3": 1822,
	"./audiofilesPlus/29-5.mp3": 1823,
	"./audiofilesPlus/29-6.mp3": 1824,
	"./audiofilesPlus/29-7.mp3": 1825,
	"./audiofilesPlus/29-8.mp3": 1826,
	"./audiofilesPlus/29-9.mp3": 1827,
	"./audiofilesPlus/3-1.mp3": 1828,
	"./audiofilesPlus/3-10.mp3": 1829,
	"./audiofilesPlus/3-2.mp3": 1830,
	"./audiofilesPlus/3-3.mp3": 1831,
	"./audiofilesPlus/3-4.mp3": 1832,
	"./audiofilesPlus/3-5.mp3": 1833,
	"./audiofilesPlus/3-6.mp3": 1834,
	"./audiofilesPlus/3-7.mp3": 1835,
	"./audiofilesPlus/3-8.mp3": 1836,
	"./audiofilesPlus/3-9.mp3": 1837,
	"./audiofilesPlus/30-1.mp3": 1838,
	"./audiofilesPlus/30-2.mp3": 1839,
	"./audiofilesPlus/30-3.mp3": 1840,
	"./audiofilesPlus/30-4.mp3": 1841,
	"./audiofilesPlus/30-5.mp3": 1842,
	"./audiofilesPlus/31-1.mp3": 1843,
	"./audiofilesPlus/31-10.mp3": 1844,
	"./audiofilesPlus/31-2.mp3": 1845,
	"./audiofilesPlus/31-3.mp3": 1846,
	"./audiofilesPlus/31-4.mp3": 1847,
	"./audiofilesPlus/31-5.mp3": 1848,
	"./audiofilesPlus/31-6.mp3": 1849,
	"./audiofilesPlus/31-7.mp3": 1850,
	"./audiofilesPlus/31-8.mp3": 1851,
	"./audiofilesPlus/31-9.mp3": 1852,
	"./audiofilesPlus/32-1.mp3": 1853,
	"./audiofilesPlus/33-1.mp3": 1854,
	"./audiofilesPlus/33-2.mp3": 1855,
	"./audiofilesPlus/33-3.mp3": 1856,
	"./audiofilesPlus/33_bsp.mp3": 1857,
	"./audiofilesPlus/34-1.mp3": 1858,
	"./audiofilesPlus/34-2.mp3": 1859,
	"./audiofilesPlus/34-3.mp3": 1860,
	"./audiofilesPlus/34_bsp.mp3": 1861,
	"./audiofilesPlus/35-1.mp3": 1862,
	"./audiofilesPlus/36-1.mp3": 1863,
	"./audiofilesPlus/36-10.mp3": 1864,
	"./audiofilesPlus/36-11.mp3": 1865,
	"./audiofilesPlus/36-12.mp3": 1866,
	"./audiofilesPlus/36-13.mp3": 1867,
	"./audiofilesPlus/36-14.mp3": 1868,
	"./audiofilesPlus/36-15.mp3": 1869,
	"./audiofilesPlus/36-2.mp3": 1870,
	"./audiofilesPlus/36-3.mp3": 1871,
	"./audiofilesPlus/36-4.mp3": 1872,
	"./audiofilesPlus/36-5.mp3": 1873,
	"./audiofilesPlus/36-6.mp3": 1874,
	"./audiofilesPlus/36-7.mp3": 1875,
	"./audiofilesPlus/36-8.mp3": 1876,
	"./audiofilesPlus/36-9.mp3": 1877,
	"./audiofilesPlus/37-1.mp3": 1878,
	"./audiofilesPlus/37-2.mp3": 1879,
	"./audiofilesPlus/38-1.mp3": 1880,
	"./audiofilesPlus/38-10.mp3": 1881,
	"./audiofilesPlus/38-2.mp3": 1882,
	"./audiofilesPlus/38-3.mp3": 1883,
	"./audiofilesPlus/38-4.mp3": 1884,
	"./audiofilesPlus/38-5.mp3": 1885,
	"./audiofilesPlus/38-6.mp3": 1886,
	"./audiofilesPlus/38-7.mp3": 1887,
	"./audiofilesPlus/38-8.mp3": 1888,
	"./audiofilesPlus/38-9.mp3": 1889,
	"./audiofilesPlus/39-1.mp3": 1890,
	"./audiofilesPlus/39-10.mp3": 1891,
	"./audiofilesPlus/39-2.mp3": 1892,
	"./audiofilesPlus/39-3.mp3": 1893,
	"./audiofilesPlus/39-4.mp3": 1894,
	"./audiofilesPlus/39-5.mp3": 1895,
	"./audiofilesPlus/39-6.mp3": 1896,
	"./audiofilesPlus/39-7.mp3": 1897,
	"./audiofilesPlus/39-8.mp3": 1898,
	"./audiofilesPlus/39-9.mp3": 1899,
	"./audiofilesPlus/4-2.mp3": 1900,
	"./audiofilesPlus/40-1.mp3": 1901,
	"./audiofilesPlus/5-1.mp3": 1902,
	"./audiofilesPlus/5-10.mp3": 1903,
	"./audiofilesPlus/5-2.mp3": 1904,
	"./audiofilesPlus/5-3.mp3": 1905,
	"./audiofilesPlus/5-4.mp3": 1906,
	"./audiofilesPlus/5-5.mp3": 1907,
	"./audiofilesPlus/5-6.mp3": 1908,
	"./audiofilesPlus/5-7.mp3": 1909,
	"./audiofilesPlus/5-8.mp3": 1910,
	"./audiofilesPlus/5-9.mp3": 1911,
	"./audiofilesPlus/6-1.mp3": 1912,
	"./audiofilesPlus/6-10.mp3": 1913,
	"./audiofilesPlus/6-2.mp3": 1914,
	"./audiofilesPlus/6-3.mp3": 1915,
	"./audiofilesPlus/6-4.mp3": 1916,
	"./audiofilesPlus/6-5.mp3": 1917,
	"./audiofilesPlus/6-6.mp3": 1918,
	"./audiofilesPlus/6-7.mp3": 1919,
	"./audiofilesPlus/6-8.mp3": 1920,
	"./audiofilesPlus/6-9.mp3": 1921,
	"./audiofilesPlus/7-1.mp3": 1922,
	"./audiofilesPlus/7-10.mp3": 1923,
	"./audiofilesPlus/7-2.mp3": 1924,
	"./audiofilesPlus/7-3.mp3": 1925,
	"./audiofilesPlus/7-4.mp3": 1926,
	"./audiofilesPlus/7-5.mp3": 1927,
	"./audiofilesPlus/7-6.mp3": 1928,
	"./audiofilesPlus/7-7.mp3": 1929,
	"./audiofilesPlus/7-8.mp3": 1930,
	"./audiofilesPlus/7-9.mp3": 1931,
	"./audiofilesPlus/8-1.mp3": 1932,
	"./audiofilesPlus/8-10.mp3": 1933,
	"./audiofilesPlus/8-2.mp3": 1934,
	"./audiofilesPlus/8-3.mp3": 1935,
	"./audiofilesPlus/8-4.mp3": 1936,
	"./audiofilesPlus/8-5.mp3": 1937,
	"./audiofilesPlus/8-6.mp3": 1938,
	"./audiofilesPlus/8-7.mp3": 1939,
	"./audiofilesPlus/8-8.mp3": 1940,
	"./audiofilesPlus/8-9.mp3": 1941,
	"./audiofilesPlus/9-1.mp3": 1942,
	"./audiofilesPlus/9-10.mp3": 1943,
	"./audiofilesPlus/9-11.mp3": 1944,
	"./audiofilesPlus/9-12.mp3": 1945,
	"./audiofilesPlus/9-13.mp3": 1946,
	"./audiofilesPlus/9-14.mp3": 1947,
	"./audiofilesPlus/9-15.mp3": 1948,
	"./audiofilesPlus/9-2.mp3": 1949,
	"./audiofilesPlus/9-3.mp3": 1950,
	"./audiofilesPlus/9-4.mp3": 1951,
	"./audiofilesPlus/9-5.mp3": 1952,
	"./audiofilesPlus/9-6.mp3": 1953,
	"./audiofilesPlus/9-7.mp3": 1954,
	"./audiofilesPlus/9-8.mp3": 1955,
	"./audiofilesPlus/9-9.mp3": 1956,
	"./audiofilesPlus/audioAdjustment.mp3": 1957,
	"./audiofilesPlus/c2.mp3": 1958,
	"./audiofilesPlus/optional/1-1.mp3": 1959,
	"./audiofilesPlus/optional/1-10.mp3": 1960,
	"./audiofilesPlus/optional/1-2.mp3": 1961,
	"./audiofilesPlus/optional/1-3.mp3": 1962,
	"./audiofilesPlus/optional/1-4.mp3": 1963,
	"./audiofilesPlus/optional/1-5.mp3": 1964,
	"./audiofilesPlus/optional/1-6.mp3": 1965,
	"./audiofilesPlus/optional/1-7.mp3": 1966,
	"./audiofilesPlus/optional/1-8.mp3": 1967,
	"./audiofilesPlus/optional/1-9.mp3": 1968,
	"./audiofilesPlus/optional/2-1.mp3": 1969,
	"./audiofilesPlus/optional/2-10.mp3": 1970,
	"./audiofilesPlus/optional/2-2.mp3": 1971,
	"./audiofilesPlus/optional/2-3.mp3": 1972,
	"./audiofilesPlus/optional/2-4.mp3": 1973,
	"./audiofilesPlus/optional/2-5.mp3": 1974,
	"./audiofilesPlus/optional/2-6.mp3": 1975,
	"./audiofilesPlus/optional/2-7.mp3": 1976,
	"./audiofilesPlus/optional/2-8.mp3": 1977,
	"./audiofilesPlus/optional/2-9.mp3": 1978,
	"./audiofilesPlus/optional/3-2.mp3": 1979,
	"./audiofilesPlus/optional/4-1.mp3": 1980,
	"./audiofilesPlus/optional/4-10.mp3": 1981,
	"./audiofilesPlus/optional/4-2.mp3": 1982,
	"./audiofilesPlus/optional/4-3.mp3": 1983,
	"./audiofilesPlus/optional/4-4.mp3": 1984,
	"./audiofilesPlus/optional/4-5.mp3": 1985,
	"./audiofilesPlus/optional/4-6.mp3": 1986,
	"./audiofilesPlus/optional/4-7.mp3": 1987,
	"./audiofilesPlus/optional/4-8.mp3": 1988,
	"./audiofilesPlus/optional/4-9.mp3": 1989,
	"./audiofilesPlus/optional/5-1.mp3": 1990,
	"./audiofilesPlus/optional/5-10.mp3": 1991,
	"./audiofilesPlus/optional/5-2.mp3": 1992,
	"./audiofilesPlus/optional/5-3.mp3": 1993,
	"./audiofilesPlus/optional/5-4.mp3": 1994,
	"./audiofilesPlus/optional/5-5.mp3": 1995,
	"./audiofilesPlus/optional/5-6.mp3": 1996,
	"./audiofilesPlus/optional/5-7.mp3": 1997,
	"./audiofilesPlus/optional/5-8.mp3": 1998,
	"./audiofilesPlus/optional/5-9.mp3": 1999,
	"./audiofilesPlus/optional/6-2.mp3": 2000,
	"./audiofilesPlus/optional/7-2.mp3": 2001,
	"./audiofilesPlus/optional/8-1.mp3": 2002,
	"./audiofilesPlus/optional/8-2.mp3": 2003,
	"./audiofilesPlus/optional/8-3.mp3": 2004,
	"./audiofilesPlus/optional/8-4.mp3": 2005,
	"./audiofilesPlus/optional/8-5.mp3": 2006,
	"./audiofilesPlus/optional/8_bsp.mp3": 2007,
	"./audiofilesPlus/optional/9-1.mp3": 2008,
	"./audiofilesPlus/optional/9-2.mp3": 2009,
	"./audiofilesPlus/optional/9-3.mp3": 2010,
	"./audiofilesPlus/optional/9-4.mp3": 2011,
	"./audiofilesPlus/optional/9-5.mp3": 2012,
	"./audiofilesPlus/optional/9_bsp.mp3": 2013,
	"./audiofilesPlus/optional/g_bsp.mp3": 2014,
	"./fonts/ITC-OfficinaSansITCPro-Book.eot": 2015,
	"./fonts/ITC-OfficinaSansITCPro-Book.otf": 2016,
	"./fonts/ITC-OfficinaSansITCPro-Book.svg": 2017,
	"./fonts/ITC-OfficinaSansITCPro-Book.ttf": 2018,
	"./fonts/ITC-OfficinaSansITCPro-Book.woff": 2019,
	"./fonts/ITC-OfficinaSansITCPro-Book.woff2": 2020,
	"./fonts/OfficinaSansITCPro-Bold.eot": 2021,
	"./fonts/OfficinaSansITCPro-Bold.otf": 2022,
	"./fonts/OfficinaSansITCPro-Bold.svg": 2023,
	"./fonts/OfficinaSansITCPro-Bold.ttf": 2024,
	"./fonts/OfficinaSansITCPro-Bold.woff": 2025,
	"./fonts/OfficinaSansITCPro-Bold.woff2": 2026,
	"./icons/arrow-left.svg": 433,
	"./icons/arrow-right.svg": 2027,
	"./icons/arrow-up.svg": 2028,
	"./icons/bird.svg": 2029,
	"./icons/cross.svg": 434,
	"./icons/exclamation.svg": 2030,
	"./icons/menu.svg": 435,
	"./icons/pause.svg": 2031,
	"./icons/play.svg": 436,
	"./icons/question.svg": 2032,
	"./icons/triangle.svg": 2033,
	"./images/exercisePlus/1-1-1.png": 437,
	"./images/exercisePlus/1-1-2.png": 438,
	"./images/exercisePlus/1-1-3.png": 439,
	"./images/exercisePlus/1-1-4.png": 440,
	"./images/exercisePlus/1-2-1.png": 441,
	"./images/exercisePlus/1-2-2.png": 442,
	"./images/exercisePlus/1-2-3.png": 443,
	"./images/exercisePlus/1-2-4.png": 444,
	"./images/exercisePlus/1-3-1.png": 445,
	"./images/exercisePlus/1-3-2.png": 446,
	"./images/exercisePlus/1-3-3.png": 447,
	"./images/exercisePlus/1-3-4.png": 448,
	"./images/exercisePlus/1-4-1.png": 449,
	"./images/exercisePlus/1-4-2.png": 450,
	"./images/exercisePlus/1-4-3.png": 451,
	"./images/exercisePlus/1-4-4.png": 452,
	"./images/exercisePlus/1-5-1.png": 453,
	"./images/exercisePlus/1-5-2.png": 454,
	"./images/exercisePlus/1-5-3.png": 455,
	"./images/exercisePlus/1-5-4.png": 456,
	"./images/exercisePlus/1-6-1.png": 457,
	"./images/exercisePlus/1-6-2.png": 458,
	"./images/exercisePlus/1-6-3.png": 459,
	"./images/exercisePlus/1-6-4.png": 460,
	"./images/exercisePlus/23-1.png": 461,
	"./images/exercisePlus/23-2.png": 462,
	"./images/exercisePlus/23-3.png": 463,
	"./images/logo.svg": 258,
	"./lang/de": 232,
	"./lang/de.json": 232,
	"./lang/en": 464,
	"./lang/en.json": 464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1112;